import Highcharts from 'highcharts';
import {standardChart, numberRange} from './utilities';

export const figure2 = {
      ...standardChart,
      xAxis: [{
        categories: numberRange(2005, 2020),
        tickInterval: 1,
        crosshair: {
            width: 1,
            color: '#d7d7d7'
        },
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
            y: 32,
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            }
        },
    }],

    yAxis: [
        {
        labels: {
            format: '{value}',
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            },
        },
        offset: 10,
        gridLineWidth: 2,
        max: 70,
        min: 0,
        tickInterval: 10,
        title: {
            text: null,
            style: {
                color: Highcharts.getOptions().colors[1]
            }
        }
    }],
    tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
            padding: 0
        }
    },
    plotOptions: {
        series: {
            states: {
                hover: {
                    lineWidth: 2
                }
            },
            marker: {
                symbol: 'circle',
                states: {
                    hover: {
                        enabled: true,
                        radius: 5
                    }
                }
            }
        }
    },
    series: [ {
        name: 'Proporción de la agricultura en el total de pérdidas económicas (%)',
        id: "prev",
        type: 'line',
        color: '#9abb59',
        zoneAxis: 'x',
        dataLabels: {
            enabled: false,
            style: {
                fontWeight: 'normal',
                textOutline: false,
                color: '#999999',
                fontSize: '12px'
            }
        },

        data: [
          { y: 19.2, dataLabels: {enabled:true} },
          { y: 41.0, dataLabels: {enabled:true} },
          { y: 24.5, dataLabels: {enabled:true} },
          { y: 35.6, dataLabels: {enabled:true} },
          { y: 60.4, dataLabels: {enabled:true} },
          { y: 54.5, dataLabels: {enabled:true} },
          { y: 38.8, dataLabels: {enabled:true} },
          { y: 37.5, dataLabels: {enabled:true} },
          { y: 50.6, dataLabels: {enabled:true} },
          { y: 56.0, dataLabels: {enabled:true} },
          { y: 25.4, dataLabels: {enabled:true} },
          { y: 35.6, dataLabels: {enabled:true} },
          { y: 13.1, dataLabels: {enabled:true} },
          { y: 18.8, dataLabels: {enabled:true} },
          { y: 64.0, dataLabels: {enabled:true} },
          { y: 63.5, dataLabels: {enabled:true} }
        ]},

        {
            name: 'Lineal (Proporción de la agricultura en el total de pérdidas económicas [%])',
            id: "lineare",
            type: 'line',
            dashStyle: 'ShortDot',
            color: '#9abb59',
            zoneAxis: 'x',
            dataLabels: {
                enabled: false,
                style: {
                    fontWeight: 'normal',
                    textOutline: false,
                    color: '#999999',
                    fontSize: '12px'
                }
            },
            marker: {
                enabled: false
            },
            connectNulls: true,
            data: [
                35,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null, 
                null,
                null,
                45
            ],
    },
  ],

}